export const SIDEBAR_IDS = {
  dashboard: "sidebar_dashboard",
  transactions: "sidebar_transactions",
  transactionsMandates: "sidebar_transactions_mandates",
  transactionsPayments: "sidebar_transactions_payments",
  transactionsRefunds: "sidebar_transactions_refunds",
  transactionsPayouts: "sidebar_transactions_payouts",
  transactionsSettlements: "sidebar_transactions_settlements",
  connect: "sidebar_connect",
  checkoutBranding: "sidebar_checkout_branding",
  customerBanksConfiguration: "sidebar_customer_banks_configuration",
  circuitBreaker: "sidebar_circuit_breaker",
  circuitBreakerAllowList: "sidebar_circuit_breaker_allow_list",
  circuitBreakerBlockList: "sidebar_circuit_breaker_block_list",
  circuitBreakerRiskRules: "sidebar_circuit_breaker_risk_rules",
  administration: "sidebar_administration",
  administrationWorkflows: "sidebar_administration_workflows",
  configuration: "sidebar_configuration",
  configurationApplications: "sidebar_configuration_applications",
  configurationBankAccount: "sidebar_configuration_bank_account",
  configurationCustomers: "sidebar_configuration_customers",
  configurationUsers: "sidebar_configuration_users",
  stablecoins: "sidebar_stablecoins",
  stablecoinsOnboarding: "sidebar_stablecoins_onboarding",
  stablecoinsPayments: "sidebar_stablecoins_payments",
  stablecoinsWallets: "sidebar_stablecoins_wallets",
  stablecoinsBeneficiaries: "sidebar_stablecoins_beneficiaries",
  stablecoinsSettlementDestinations: "sidebar_stablecoins_settlement_destinations",
  connectGroup: "sidebar_connect_group",
  voltAccounts: "sidebar_volt_accounts",
  voltAccountsOverview: "sidebar_volt_accounts_overview",
  voltAccountsConfiguration: "sidebar_volt_accounts_configuration",
  voltAccountsBeneficiaries: "sidebar_volt_accounts_beneficiaries",
  voltAccountsPayments: "sidebar_volt_accounts_payments",
  voltAccountsAccounts: "sidebar_volt_accounts_accounts",
  voltAccountsConnect: "sidebar_volt_accounts_connect",
} as const satisfies Record<string, `sidebar_${string}`>;
